// Parse owner and repo from complete github complete url
export const extractRepositoryOwnerAndRepo = (repositoryUrl: string) => {
  let url = repositoryUrl;
  if (!url.endsWith('.git')) url = `${url}.git`;

  const regex = /https:\/\/github\.com\/(.*)\.git/g.exec(url);
  if (!regex || !regex[1]) return { status: 'error' as const };
  const [owner, repo] = regex[1]?.split('/') || [];
  return { status: 'ok' as const, owner, repo };
};
